<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M21.75 7.125c-.8284 0-1.5.67157-1.5 1.5v5.25H1.125V19.5c0 .8284.67157 1.5 1.5 1.5s1.5-.6716 1.5-1.5v-2.625H20.25V19.5c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5V8.625c0-.82843-.6716-1.5-1.5-1.5Z"
        />
        <path
            d="M13.875 13.125H1.1404C1.33096 10.8152 3.266 9 5.625 9h8.25v4.125Zm5.625-2.0625c0 1.3462-1.0913 2.4375-2.4375 2.4375s-2.4375-1.0913-2.4375-2.4375c0-1.34619 1.0913-2.4375 2.4375-2.4375S19.5 9.71631 19.5 11.0625Z"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M21 7c.5523 0 1 .44772 1 1v12c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3H4v3c0 .5523-.44772 1-1 1s-1-.4477-1-1v-4c0-2.7615 2.23869-5 5.00009-5H13.5v4H20V8c0-.55228.4477-1 1-1Zm-9.5 8v-2H7.00009c-1.30624 0-2.41752.8348-2.82937 2H11.5Z"
            clip-rule="evenodd"
        />
        <path
            fill-rule="evenodd"
            d="M16.7461 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Zm0 2c1.6568 0 3-1.3431 3-3s-1.3432-3-3-3c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
